import React from 'react'

const Bookmark = () => {
  return (
    <div className='site-info'>Site under construction...</div>
  )
}

export default Bookmark